import { ref } from 'vue'
import { sdk } from '@/graphql/client'
import type { AdminTicketInfoDataQuery } from '@/graphql/generated/sdk'

export type TicketInfoData = NonNullable<
    NonNullable<NonNullable<AdminTicketInfoDataQuery['admin']>['ticket']>['infoData']
>

export function useTicketVerify() {
    const loading = ref(false)
    // Set only on a thrown request/network failure. A "ticket not found / out of
    // scope" outcome is NOT an error here — the backend returns a payload with
    // `ok: false`, so the view branches on `result.ok` for that case.
    const error = ref<string | null>(null)
    const result = ref<TicketInfoData | null>(null)
    const lastCode = ref('')

    async function load(code: string) {
        const trimmed = code.trim()
        if (!trimmed) return
        loading.value = true
        error.value = null
        result.value = null
        lastCode.value = trimmed
        try {
            const res = await sdk.AdminTicketInfoData({ code: trimmed })
            result.value = res.admin?.ticket?.infoData ?? null
        } catch (e) {
            error.value = (e as Error).message || 'request_failed'
            result.value = null
        } finally {
            loading.value = false
        }
    }

    function reset() {
        result.value = null
        error.value = null
        lastCode.value = ''
    }

    return { loading, error, result, lastCode, load, reset }
}
